import * as G from "@globals";
import type { StoreNames, } from "idb";
import { getIDB, } from "./IDB";
import type { PlatformDBSchema, } from "./types";

export const dehydrate = async <S extends keyof PlatformDBSchema>( name: S, props: PlatformDBSchema[S]["value"], ) => {

	const { search, } = globalThis.location;
	if(search.toLowerCase().includes("cache=false")) {
		return;
	}

	if(!search.toLowerCase().includes("hydrate=true")) {
		if(!["swap", "platform", "vaults", "bars_leaderboard", "bars_points", "wallet_points",].includes(name as string)) {
			return;
		}
	}

	const clean = cleanProps(props);
	const db = await getIDB();
	const txn = db.transaction(name as StoreNames<PlatformDBSchema>, "readwrite");
	const store = txn.objectStore(name as StoreNames<PlatformDBSchema>);
	const { address, } = G.wallet.getBracketWallet();
	if(address) {
		try {
			const result = await store.put({ id: address, value: JSON.stringify(clean), });
			return result;
		}
		catch(err) {
			console.error("ERROR DEHYDRATING", err);
			console.log("CLEAN", clean);
		}
	}
	return;

}

const cleanProps = <S extends keyof PlatformDBSchema>( props: PlatformDBSchema[S]["value"], ): PlatformDBSchema[S]["value"] => {
	const result = Object.entries(props).reduce((acc, [vkey, value]) => {
		const key = vkey as string; // really....
		if(opkeys.includes(key) || typeof value === "function" || value === null) {
			return acc;
		}
		return Object.assign({}, acc, { [key]: value, });
	}, {});

	return result as PlatformDBSchema[S]["value"];

} 

const opkeys = [ "ready", "fetching", "isLoading", "isError", "error", ];

